import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const usePlaylistOptions = () => {
  const {
    data: playlistOptions,
    isLoading: isPlaylistOptionsLoading,
    refetch: refetchPlaylistOptions,
  } = useQuery({
    queryKey: ["playlistOptions"],
    queryFn: () => dropdownService.getPlaylistOptions(),
  });

  return {
    playlistOptions: playlistOptions || [],
    isPlaylistOptionsLoading,
    refetchPlaylistOptions,
  };
};
